import React from 'react';
import { FormField } from 'ui/formField';
import { pxToRem } from 'utils/convert';
import { numberRangeThemes } from 'utils/themes';
import { StyledRadio } from './components/StyledRadio';
import { StyledNumberRangeThemePicker } from './customWidgetSettings.styled';

// type Props = {
//   /** Callback function when value is changed. */
//   onChange: () => void,
//   /** Definition of the range theme containing the themeName, min and max values. */
//   value: {},
// };

export default class NumberRangeTheme extends React.Component {
  static defaultProps = {
    value: {
      customTheme: 0,
      themeName: numberRangeThemes.default.name,
      min: 0,
      max: 100,
      reverse: false,
    },
  };

  /**
   * getValues
   * Helper function to get the values from the props.
   * @returns { Object } The values used for the NumberRangeThemePicker.
   */
  getValues = () => {
    const { value } = this.props;
    const { customTheme, min, max, reverse, themeName } = value;
    return { customTheme, min: parseFloat(min, 10), max: parseFloat(max, 10), reverse, themeName };
  };

  /**
   * handleChangeMinMax
   * Callback function when the min or max value is changed.
   * @param { Object } e: The change event.
   * @param { Object } props: The props of the number input containing the updated min and max value.
   * @returns { void }
   */
  handleChangeMinMax = (e, { min, max }) => {
    this.props.onChange(e, {
      value: {
        ...this.getValues(),
        customTheme: 0,
        min: min || 0,
        max: max || 0,
      },
    });
  };

  /**
   * handleChangeTheme
   * Callback function when theme is changed.
   * @param { Object } e: The change event.
   * @param { Object } props: The props of the NumberRangeThemePicker containing updated values.
   * @returns { void }
   */
  handleChangeTheme = (e, { value, reverse }) => {
    this.props.onChange(e, {
      value: {
        ...this.getValues(),
        customTheme: 0,
        reverse,
        themeName: value,
      },
    });
  };

  /**
   * handleChangeCustomTheme
   * Callback function when custom theme toggle is changed.
   * @param { Object } e: The change event.
   * @param { Object } props: The props of the toggle containing updated value.
   * @returns { void }
   */
  handleChangeCustomTheme = (e, { value }) => {
    this.props.onChange(e, {
      value: {
        ...this.getValues(),
        customTheme: value,
      },
    });
  };

  render() {
    const { customTheme, min, max, reverse, themeName } = this.getValues();

    return (
      <div>
        <FormField style={{ display: 'flex', alignItems: 'flex-start' }}>
          <StyledRadio
            name="numberRangeTheme"
            value={0}
            isChecked={customTheme === 0}
            onClick={this.handleChangeCustomTheme}
            style={{ marginTop: pxToRem(3) }}
          />
          <StyledNumberRangeThemePicker
            disabled={customTheme}
            min={min}
            max={max}
            onChange={this.handleChangeTheme}
            onChangeMinMax={this.handleChangeMinMax}
            reverse={reverse}
            showMinMax={!customTheme}
            value={themeName}
          />
        </FormField>
        <FormField>
          <StyledRadio
            data-test="custom-number-range"
            label="Custom"
            name="customNumberRange"
            value={1}
            isChecked={customTheme === 1}
            onClick={this.handleChangeCustomTheme}
          />
        </FormField>
      </div>
    );
  }
}
